export default {
  // Tooltip 内容
  selectAll: "全选 (ctrl+a/command+a)",
  invertSelect: "反选",
  verticalArrange: "纵向排列（只支持单列）",
  backToCenter: "回到中心",
  deleteNode: "删除节点 (delete)",
  previousStep: "上一步 (ctrl+z/command+z)",
  nextStep: "下一步 (ctrl+f/command+f)",
  saveCanvas: "保存画布 (alt+s/⌥+s)",
  fullScreen: "全屏 ",
  exitFullScreen: "取消全屏",

  // emit 事件文本
  saveCanvasAction: "保存画布",
  fullScreenCanvas: "全屏画布",
  exitFullScreenAction: "取消全屏",
  relevance: "关联",
};
